import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-video",
  "use": "icon-video-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol viewBox=\"0 0 64 64\" id=\"icon-video\">\n  <path d=\"M6 10V12V54H58V10H6ZM10 14H54V50H10V14ZM14 18V22H18V18H14ZM22 18V22H26V18H22ZM30 18V22H34V18H30ZM38 18V22H42V18H38ZM46 18V22H50V18H46ZM28 26V38L38 32L28 26ZM14 42V46H18V42H14ZM22 42V46H26V42H22ZM30 42V46H34V42H30ZM38 42V46H42V42H38ZM46 42V46H50V42H46Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol